export enum MfaStatus {
  INACTIVE = 'INACTIVE',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}